// extracted by mini-css-extract-plugin
export default {"not_found":"NotFound_not_found__NCtSn","image":"NotFound_image__D8NAc","title":"NotFound_title__uMI+Q"};